export interface CareersBenefit {
  // Which slot on the page this item fills. The page matches on it, so an editor
  // can reorder the list without the layouts moving with it.
  key: string
  title: string
  description: string
  image: string
}

interface CareersBenefitSerializerInput {
  key?: string
  title?: string
  description?: string
  image?: string
}

export function CareersBenefitSerializer(
  input: CareersBenefitSerializerInput,
): CareersBenefit {
  return {
    key: input.key ?? "",
    title: input.title ?? "",
    description: input.description ?? "",
    // Empty means no upload in Strapi. Nothing is bundled with the frontend any
    // more, so an item with no upload renders without an illustration.
    image: input.image ?? "",
  }
}
